import { downloadDataUrl } from "@opendash/core";
import { RouteContext } from "@opendash/router";
import JSZip from "jszip";
import papa from "papaparse";
import Parse from "parse";
import {
  Agency,
  Calendar,
  Route,
  Stop_Times,
  Trip,
} from "../js/parsegenerated";
import {
  mapCSVDataTypeAgency,
  mapCSVDataTypeCalendar,
  mapCSVDataTypeRoute,
  mapCSVDataTypeStop,
  mapCSVDataTypeStopTimes,
  mapCSVDataTypeTrip,
} from "../types/csvDataTypes";

export class ExportPageState {
  ctx: RouteContext;

  constructor(ctx: RouteContext) {
    this.ctx = ctx;

    ctx.setTitle("gtfs:export.title");
    ctx.setDescription("Export der Daten im GTFS-Format");
  }

  async downloadExport(agency: Agency) {
    // fetch data

    const agencies = [agency];

    const routes = await new Parse.Query(Route)
      .equalTo("agency_id", agency)
      .limit(1_000_000)
      .find();

    const trips = await new Parse.Query(Trip)
      .containedIn("route_id", routes)
      .include(["direction_id", "bikes_allowed", "wheelchair_accessible"])
      .limit(1_000_000)
      .find();

    const stopTimes = await new Parse.Query(Stop_Times)
      .containedIn("trip_id", trips)
      .include("stop_id")
      .limit(1_000_000)
      .find();

    const stops = stopTimes
      .map((stopTime) => stopTime.stop_id)
      .filter((v, i, a) => a.findIndex((v2) => v2.id === v.id) === i);

    const calendar = await new Parse.Query(Calendar)
      .greaterThanOrEqualTo("end_date", new Date())
      .find();

    // transform to gtfs csv format

    const agenciesCsvArray = agencies.map(mapCSVDataTypeAgency);
    const routesCsvArray = routes.map(mapCSVDataTypeRoute);
    const tripsCsvArray = trips.map(mapCSVDataTypeTrip);
    const stopTimesCsvArray = stopTimes.map(mapCSVDataTypeStopTimes);
    const stopsCsvArray = stops.map(mapCSVDataTypeStop);
    const calendarCsvArray = calendar.map(mapCSVDataTypeCalendar);

    // transform to csv files

    const agencyCsvText = papa.unparse(agenciesCsvArray);
    const routesCsvText = papa.unparse(routesCsvArray);
    const tripsCsvText = papa.unparse(tripsCsvArray);
    const stopTimesCsvText = papa.unparse(stopTimesCsvArray);
    const stopsCsvText = papa.unparse(stopsCsvArray);
    const calendarCsvText = papa.unparse(calendarCsvArray);

    // create zip

    const zip = new JSZip();

    zip
      .file("agency.txt", new Blob([agencyCsvText]))
      .file("routes.txt", new Blob([routesCsvText]))
      .file("trips.txt", new Blob([tripsCsvText]))
      .file("stop_times.txt", new Blob([stopTimesCsvText]))
      .file("stops.txt", new Blob([stopsCsvText]))
      .file("calendar.txt", new Blob([calendarCsvText]));

    const zipContent = await zip.generateAsync({ type: "base64" });

    downloadDataUrl(
      `gtfs_${agency.id}.zip`,
      "data:application/zip;base64," + zipContent
    );
  }
}
